/****************************************************
 * Module Name:  addUserModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "./../../utility/constants";
import UserProxy from "./../../utility/proxy/manager/userProxy";
import Select from "react-select";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import "bootstrap/dist/css/bootstrap.min.css";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import DesignationProxy from "../../utility/proxy/manager/designationProxy";
import { Box, Button, Checkbox, FormControlLabel, TextField, Tooltip, Typography, } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddUserModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newcompanyname: this.props.editOperation
        ? this.props.sourceData.companyname
          ? this.props.sourceData.companyname
          : ""
        : "",
      newusername: this.props.editOperation
        ? this.props.sourceData.username
        : "",
      newUserType:
        this.props.sourceData !== undefined
          ? this.props.editOperation ||
            (!this.props.editOperation && this.props.sourceData.usertype)
            ? {
              value: this.props.sourceData.usertype,
              label: Constants.USER_TYPE[this.props.sourceData.usertype],
            }
            : { value: 0, label: "Error" }
          : { value: 0, label: "Error" },
      newGrade: this.props.editOperation
        ? {
          value: this.props.sourceData.grade,
          label: this.props.sourceData.grade,
        }
        : { value: 0, label: "Error" },
      newfirst_name: this.props.editOperation
        ? this.props.sourceData.first_name
        : "",
      newmiddle_name: this.props.editOperation
        ? this.props.sourceData.middle_name
          ? this.props.sourceData.middle_name
          : ""
        : "",
      newlast_name: this.props.editOperation
        ? this.props.sourceData.last_name
          ? this.props.sourceData.last_name
          : ""
        : "",
      newdesignation: this.props.editOperation
        ? this.props.sourceData.designation
        : "",
      newemployeeid: this.props.editOperation
        ? this.props.sourceData.employeeid
          ? this.props.sourceData.employeeid
          : ""
        : "",
      newlocationid: this.props.editOperation
        ? this.props.sourceData.locationid
        : "",
      newfullLocation: this.props.editOperation
        ? {
          value: this.props.sourceData.locationid,
          label: this.props.sourceData.location,
        }
        : { value: 0, label: "Error" },
      newGstNo: this.props.editOperation
        ? this.props.sourceData.gstinno
          ? this.props.sourceData.gstinno
          : ""
        : "",
      newPanNo: this.props.editOperation
        ? this.props.sourceData.panno
          ? this.props.sourceData.panno
          : ""
        : "",
      newdeleted: this.props.editOperation
        ? this.props.sourceData.deleted
        : false,
      newdisabled: this.props.editOperation
        ? this.props.sourceData.disabled
        : false,
      newSpecialUser: this.props.editOperation
        ? this.props.sourceData.specialuser
        : false,
      newEmail: this.props.editOperation ? this.props.sourceData.email : "",
      newPhone: this.props.editOperation ? this.props.sourceData.phone : "",
      newCreated: this.props.editOperation ? this.props.sourceData.created : "",
      newCreatedBy: this.props.editOperation ? (this.props.sourceData.createdby === null ? Constants.loggedInUser.username : this.props.sourceData.createdby) : Constants.loggedInUser.username,

      showError: false,
      showTypeMsg: false,

      validateUserPresentSpinner: false,
      showValidationMessage: false,
      userNameAvailable: true,

      fullLocation: [],
      fullLocationOptions: [],
      showLocationLoadSpinner: true,

      allUserType: [],
      allGrades: [],

      designationOptions: [],
      showDesignationLoadSpinner: true,

      userNameValidationError: "",
      firstNameValidationError: "",
      newPanNoValidationError: "",
    };
    this.getAllLocationList(false);
    this.getAllDesignationList(false);
    if (this.props.sourceData === undefined) {
      this.getUserById();
    }
  }

  getUserById = () => {
    UserProxy.GetSingleUserDetail(this.props.userId, (response) =>
      this.setState({
        newcompanyname:
          response !== null &&
            response !== undefined &&
            response.companyname !== null
            ? response.companyname
            : "",
        newusername:
          response !== null &&
            response !== undefined &&
            response.username !== null
            ? response.username
            : "",
        newUserType:
          response !== null &&
            response !== undefined &&
            response.usertype !== null
            ? {
              value: response.usertype,
              label: Constants.USER_TYPE[response.usertype],
            }
            : { value: "", label: "error" },
        newGrade:
          response !== null && response !== undefined && response.grade !== null
            ? { value: response.grade, label: response.grade }
            : { value: "", label: "error" },
        newfirst_name:
          response !== null &&
            response !== undefined &&
            response.first_name !== null
            ? response.first_name
            : "",
        newmiddle_name:
          response !== null &&
            response !== undefined &&
            response.middle_name !== null
            ? response.middle_name
            : "",
        newlast_name:
          response !== null &&
            response !== undefined &&
            response.last_name !== null
            ? response.last_name
            : "",
        newdesignation:
          response !== null &&
            response !== undefined &&
            response.designation !== null
            ? response.designation
            : "",
        newemployeeid:
          response !== null &&
            response !== undefined &&
            response.employeeid !== null
            ? response.employeeid
            : "",
        newlocationid:
          response !== null &&
            response !== undefined &&
            response.locationid !== null
            ? response.locationid
            : "",
        newfullLocation:
          response !== null &&
            response !== undefined &&
            response.location !== null
            ? {
              value: response.locationid,
              label: response.location + " | " + response.country,
            }
            : { value: "", label: "error" },
        newGstNo:
          response !== null &&
            response !== undefined &&
            response.gstinno !== null
            ? response.gstinno
            : "",
        newPanNo:
          response !== null && response !== undefined && response.panno !== null
            ? response.panno
            : "",
        newdeleted:
          response !== null &&
            response !== undefined &&
            response.deleted !== null
            ? response.deleted
            : "",
        newdisabled:
          response !== null &&
            response !== undefined &&
            response.disabled !== null
            ? response.disabled
            : "",
        newSpecialUser: response.specialuser,
        newEmail: response.email,
        newPhone: response.phone,
        newCreated: response.created,
        newCreatedBy: response.createdby,
      })
    );
  };

  getAllLocationList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showLocationLoadSpinner: true });
    LocationProxy.GetAllLocationDetailMini((response) =>
      this.setAllLocationData(response)
    );
  };

  setAllLocationData = (response) => {
    this.setAllUserType();
    this.setAllGrades();
    let cOptions = [];
    let nnewfullLocation = this.state.newfullLocation;
    response.map((data) => {
      let iOption = { value: data.id, label: data.name + " | " + data.country };
      cOptions.push(iOption);

      if (data.id === this.state.newfullLocation.value)
        nnewfullLocation = iOption;
      return true;
    });

    //During new creation option select first one as default
    if (nnewfullLocation.value === 0 && cOptions.length > 0)
      nnewfullLocation = cOptions[0];

    this.setState({
      fullLocation: response,
      fullLocationOptions: cOptions,
      newfullLocation: nnewfullLocation,
      showLocationLoadSpinner: false,
    });
  };

  setAllUserType = () => {
    let optionsArray = [];
    Object.keys(Constants.USER_TYPE).map((key) => {
      let option = { value: key, label: Constants.USER_TYPE[key] };
      optionsArray.push(option);
      return true;
    });
    this.setState({
      allUserType: optionsArray,
      newUserType:
        this.state.newUserType.value === 0 && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newUserType,
    });
  };

  setAllGrades = () => {
    let optionsArray = [];
    Constants.GRADES.map((grade) => {
      let option = { value: grade, label: grade };
      optionsArray.push(option);
      return true;
    });
    this.setState({
      allGrades: optionsArray,
      newGrade:
        this.state.newGrade.value === 0 && optionsArray.length > 0
          ? optionsArray[2]
          : this.state.newGrade,
    });
  };

  getAllDesignationList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showDesignationLoadSpinner: true });
    DesignationProxy.GetAllDesignation((response) =>
      this.setAllDesigationData(response)
    );
  };

  setAllDesigationData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.name, label: data.name };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      designationOptions: optionsArray,
      newdesignation:
        this.state.newdesignation === "" && optionsArray.length > 0
          ? optionsArray[0].value
          : this.state.newdesignation,
      showDesignationLoadSpinner: false,
    });
  };

  handleSave = () => {
    let data = {
      id:
        this.props.sourceData === undefined
          ? this.props.userId
          : this.props.editOperation
            ? this.props.sourceData.id
            : undefined,
      companyname: this.state.newcompanyname.trim(),
      username: this.state.newusername,
      first_name: this.state.newfirst_name,
      middle_name: this.state.newmiddle_name,
      last_name: this.state.newlast_name,
      designation: this.state.newdesignation,
      employeeid: this.state.newemployeeid,
      locationid: this.state.newfullLocation.value,
      discount: 0,
      commission: 0,
      gstinno: this.state.newGstNo,
      panno: this.state.newPanNo,
      deleted: this.state.newdeleted,
      disabled: this.state.newdisabled,
      usertype: this.state.newUserType.value,
      grade: this.state.newGrade.value,
      specialuser: this.state.newSpecialUser,
      email: this.state.newEmail,
      phone: this.state.newPhone,
      created: this.state.newCreated,
      createdby: this.state.newCreatedBy,
      labgrowndiscount: 0,
      labgrowncommission: 0,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateUserPresent = (userNameEntered) => {
    if (!userNameEntered || userNameEntered.trim() === "") return;

    this.setState({
      validateUserPresentSpinner: true,
    });

    UserProxy.CheckUserNameAvailable(userNameEntered, (response) => {
      //if we got response that means user is present at backend
      if (response) {
        //Username already present
        this.setState({
          validateUserPresentSpinner: false,
          showValidationMessage: true,
          userNameAvailable: false,
        });
      } else {
        //Username not available, so can be used
        this.setState({
          validateUserPresentSpinner: false,
          showValidationMessage: true,
          userNameAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      this.state.newfirst_name.length === 0
    ) {
      return true;
    }
    if (
      (this.props.sourceData === undefined &&
        this.state.newfirst_name.length === 0)
    ) {
      return true;
    } else if (
      (!this.props.editOperation && this.props.sourceData !== undefined)
    ) {
      return (
        !this.state.showValidationMessage ||
        !this.state.userNameAvailable ||
        this.state.newfirst_name.length === 0
      );
    }

    if (this.state.newUserType.value === null) return true;

    if (this.state.newPanNo === "" && this.state.newPanNoValidationError.length > 0) return true;

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add user validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" dialogClassName="modal" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation || !this.props.sourceData
                ? "Edit User"
                : "Add New User"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box>
              {this.props.editOperation && (
                <Box sx={{ display: "flex", width: "100%" }} mb={2}>
                  <Typography sx={{ width: "24%" }}>User Id</Typography>
                  <Typography sx={{ fontWeight: Constants.defaultFontWeightBold }}>
                    {this.props.sourceData.id}
                  </Typography>
                </Box>
              )}
              {!this.props.sourceData && (
                <Box sx={{ display: "flex", width: "100%" }} mb={2}>
                  <Typography sx={{ width: "24%" }}>User Id</Typography>
                  <Typography sx={{ fontWeight: Constants.defaultFontWeightBold }}>
                    {this.props.userId}
                  </Typography>
                </Box>
              )}
              <Box display={"flex"} alignItems={"center"} mb={2}>
                <Typography
                  sx={{
                    width:
                      this.props.editOperation || !this.props.sourceData
                        ? "24%"
                        : "30%",
                  }}
                >
                  Username <sup style={{ color: "red" }}>*</sup>
                </Typography>
                {this.props.editOperation || !this.props.sourceData ? (
                  <Typography style={{ fontWeight: Constants.defaultFontWeightBold }} width="76%">{this.state.newusername}</Typography>
                ) : (
                  <TextField
                    margin="normal"
                    fullWidth
                    size="small"
                    label="Username (required)"
                    placeholder="Enter Username"
                    value={this.state.newusername}
                    autoFocus
                    onBlur={(e) =>
                      this.validateUserPresent(this.state.newusername)
                    }
                    onChange={(e) =>
                      this.setState({
                        newusername: e.target.value,
                        showValidationMessage: false,
                        userNameValidationError: Utility.CheckIsPresent(
                          e.target.value
                        )
                          ? ""
                          : "Username Cannot be Empty",
                      })
                    }
                    helperText={this.state.userNameValidationError}
                    error={this.state.userNameValidationError.length > 0}
                  />
                )}
              </Box>
              <Box display={"flex"}>
                <Box width={"24%"}></Box>
                <Box>
                  {this.state.validateUserPresentSpinner ? (
                    <CircularProgress size="1rem" />
                  ) : !this.state.showValidationMessage ? (
                    <Box></Box>
                  ) : this.state.userNameAvailable ? (
                    <font color="green">Username available</font>
                  ) : (
                    <font color="red">Username not available</font>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "30%" }}>
                  First Name <sup style={{ color: "red" }}>*</sup>
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="First Name (required)"
                  placeholder="Enter First Name"
                  value={this.state.newfirst_name}
                  onChange={(e) =>
                    this.setState({
                      newfirst_name: e.target.value.trim(),
                      firstNameValidationError: Utility.CheckIsPresent(
                        e.target.value
                      )
                        ? ""
                        : "First Name Cannot be Empty ",
                    })
                  }
                  helperText={this.state.firstNameValidationError}
                  error={this.state.firstNameValidationError.length > 0}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>Middle Name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="Middle Name"
                  placeholder="Enter Middle Name"
                  value={this.state.newmiddle_name}
                  onChange={(e) =>
                    this.setState({ newmiddle_name: e.target.value.trim() })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>Last Name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="Last Name"
                  placeholder="Enter Last Name"
                  value={this.state.newlast_name}
                  onChange={(e) =>
                    this.setState({ newlast_name: e.target.value.trim() })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>Company Name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="Company Name"
                  placeholder="Enter Company Name"
                  value={this.state.newcompanyname}
                  onChange={(e) =>
                    this.setState({ newcompanyname: e.target.value })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  User Type
                </Typography>
                <Box sx={{ width: "77%", mb: 1 }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.allUserType.find(
                      (userType) =>
                        userType.value === this.state.newUserType.value
                    )}
                    isSearchable={true}
                    name="UserType"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.state.allUserType}
                    onChange={(selectedOption) => {
                      if (selectedOption.value !== this.props.sourceData.usertype) {
                        this.setState({
                          showTypeMsg: true
                        })
                      } else {
                        this.setState({
                          showTypeMsg: false
                        })
                      }
                      this.userTypeChangeHandler(selectedOption)
                    }
                    }
                    isDisabled={
                      !this.props.sourceData
                        ? this.props.userId === Constants.loggedInUser.id
                        : this.props.sourceData.id === Constants.loggedInUser.id
                    }
                  />
                  {
                    this.props.editOperation && this.state.showTypeMsg ?
                      <Typography color={'orangered'}>
                        Changing the user type will affect all of his connection
                      </Typography>
                      : this.state.newUserType.value === null
                        ? <span style={{ color: 'red' }}>Please Select User Type</span> : ""
                  }
                </Box>
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Grade
                </Typography>
                <Box sx={{ width: "77%", mb: 1 }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.allGrades.find(
                      (grade) => grade.value === this.state.newGrade.value
                    )}
                    isSearchable={true}
                    name="Grades"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.state.allGrades}
                    onChange={(selectedOption) =>
                      this.setState({ newGrade: selectedOption })
                    }
                    isDisabled={
                      !this.props.sourceData
                        ? this.props.userId === Constants.loggedInUser.id
                        : this.props.sourceData.id === Constants.loggedInUser.id
                    }
                  />
                </Box>
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Designation
                </Typography>
                <Box sx={{ width: "72%", mb: 1 }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.designationOptions.find(
                      (iDesig) => iDesig.value === this.state.newdesignation
                    )}
                    isSearchable={true}
                    name="Designation"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.state.designationOptions}
                    onChange={(selectedOption) =>
                      this.setState({
                        newdesignation: selectedOption.value,
                      })
                    }
                  />
                </Box>
                {this.state.showDesignationLoadSpinner ? (
                  <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllDesignationList(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>Employee Id.</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="Employee Id"
                  placeholder="Enter Employee Id"
                  value={this.state.newemployeeid}
                  onChange={(e) =>
                    this.setState({ newemployeeid: e.target.value })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 2, mb: 1 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Location
                </Typography>

                <Box sx={{ width: "72%", mb: 1 }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.newfullLocation}
                    isSearchable={true}
                    name="Location"
                    options={this.state.fullLocationOptions}
                    onChange={(selectedOption) =>
                      this.setState({ newfullLocation: selectedOption })
                    }
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                  />
                </Box>
                {this.state.showLocationLoadSpinner ? (
                  <CircularProgress size="1rem" sx={{ mt: 1 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllLocationList(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>GSTN</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="GST No"
                  placeholder="Enter GST number"
                  value={this.state.newGstNo}
                  onChange={(e) => {
                    this.setState({
                      newGstNo: e.target.value.replace(/[^\w\s]/gi, ""),
                    });
                  }}
                  disabled={this.state.newUserType.value === "E"}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>PAN</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="PAN No"
                  placeholder="Enter PAN number"
                  value={this.state.newPanNo}
                  onChange={(e) => {
                    this.setState({
                      newPanNo: e.target.value.trim(),
                      newPanNoValidationError: e.target.value
                        ? "" : "Pan No can't be Empty",
                    });
                  }}
                  helperText={this.state.newPanNoValidationError}
                  error={this.state.newPanNoValidationError.length > 0}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Box sx={{ width: "24%" }}></Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.newdeleted}
                        onChange={(e) =>
                          this.setState({
                            newdeleted: !this.state.newdeleted,
                          })
                        }
                      />
                    }
                    label="Deleted"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.8rem",
                      },
                    }}
                  />
                </Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.newdisabled}
                        onChange={(e) =>
                          this.setState({
                            newdisabled: !this.state.newdisabled,
                          })
                        }
                      />
                    }
                    label="Disabled"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.8rem",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            {this.props.saveButton ? (
              <LoadingButton
                variant="contained"
                loading={this.props.loading}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                onClick={() => this.handleSave()}
                disabled={this.buttonDisable()}
                sx={{ mr: 1 }}
              >
                Save
              </LoadingButton>
            ) : null}
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
